import { inject, Injectable, signal } from '@angular/core';
import { UserDTO } from 'src/app/dto/responses/UserDTO';
import { UserPublicProfileDTO } from 'src/app/dto/responses/UserPublicProfileDTO';
import { ApiService } from '../api/api.service';
import { StorageService } from '../storage/storage.service';
import { USER_KEY } from '../../constants';
import { firstValueFrom, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class UserService {

  private storageService = inject(StorageService);
  private apiService = inject(ApiService);

  private user$ = signal<UserDTO | null>(null);
  public user = this.user$.asReadonly();

  public getUser(): Observable<UserDTO> {
    return this.apiService.get<UserDTO>('/api/users/me')
  }

  public getUserPublicProfile(userId: string): Observable<UserPublicProfileDTO> {
    return this.apiService.get<UserPublicProfileDTO>(`/api/users/${userId}/profile`);
  }

  public reloadUser(): Promise<void> {
    return firstValueFrom(this.getUser()).then(x => {
      this.saveUser(x);
    });
  }

  public async saveUser(user: UserDTO) {
    await this.storageService.set(USER_KEY, user);
    await this.setUser();
  }
  public async clearUser() {
    this.storageService.remove(USER_KEY);
  }
  public async getUserStorage(userkey: any): Promise<UserDTO> {
    return this.storageService.get(userkey);

  }

  private async setUser() {
    const user: UserDTO = await this.storageService.get(USER_KEY);
    this.user$.set(user);

  }
}
